export class SolicitacaoContatoModel {
    forma_contato: string;
    data: string;
    hora: string;
    especialidade: string;
    especialidades: Array<string>;
    formas_contato: Array<string>;
}


// WEBPACK FOOTER //
// ./src/pages/solicitacao-contato/solicitacao-contato.modelview.ts